import each from 'lodash-es/each';
// import { drop, size } from 'lodash-es';
// import { clearAllBodyScrollLocks } from 'body-scroll-lock';
// import { number } from 'prop-types';

let module_name = '';

const extractTableHeadingRow = (row) => {
  const cell_html = [];
  each(row, (cell) => {
    if (cell.c !== 'SIZE' && cell.c !== '' && cell.c !== 'KNIT') {
      cell_html.push(
        `<th class="Module-${module_name}__Table-Header--Cell" data-size-guide-cell data-size-guide-heading-cell>${cell.c}</th>`,
      );
    }
  });
  const html = `
    <tr class="Module-${module_name}__Table-Header-mobile">
      ${cell_html.join('')}
    </tr>
  `;
  return html;
};

const sizes = ['S', 'XS', 'M', 'L', 'XL', 'XXL'];
const numberSizes = ['0, 1', '1', '3-5', '7-9', '11-13', '15', '2-4, 3-5', '6-8, 7-9', '10-12, 11-13', '14, 15', ''];

const extractDropdown = (rows) => {
  const row_html = [];
  each(rows, (row) => {
    var option_content = '';
    // var row_head = '';
    // each(row, (cell, index) => {
    each(row, (cell) => {
      if (sizes.includes(cell.c)) {
        // row_head = cell.c;
        option_content += cell.c;
      }
      if (numberSizes.includes(cell.c)) {
        // row_head = cell.c;
        option_content += ` (${cell.c})`;
      }
    });

    row_html.push(
      `<option value="${option_content}" data-size-guide-cell data-size-guide-body-cell>${option_content}</option>`,
    );
  });
  const html = `
      ${row_html.join('')}
  `;
  return html;
};

const extractTableHeadingBody = (rows) => {
  const body_html = [];
  // each(rows, (row, index) => {
  each(rows, (row) => {
    const row_html = [];
    // each(row, (cell, index) => {
    each(row, (cell) => {
      // let row_head = '';
      // if (index === 0) {
      // row_head = `Module-${module_name}__Table-Body--Row--Title`;
      // }

      if (!sizes.includes(cell.c) && !numberSizes.includes(cell.c)) {
        row_html.push(
          `<td class="Module-${module_name}__Table-Body--Cell" data-size-guide-cell data-size-guide-body-cell>${cell.c}</td>`,
        );
      }
    });
    body_html.push(
      `<tr id="${row[0].c} (${
        row[1].c
      })" class="Module-${module_name}__Table-Body--Mobile--Row table-body-rows">${row_html.join('')}</tr>`,
    );
  });
  const html = `
    ${body_html.join('')}
  `;
  return html;
};

const contiansKnitWoven = (rows) => {
  if (rows[0].c == 'KNIT') {
    return true;
  }

  return false;
};
export default (settings, name) => {
  module_name = name;

  const dropdown = extractDropdown(settings.size_guide.body);
  const table_heading = extractTableHeadingRow(settings.size_guide.header);
  const table_body = extractTableHeadingBody(settings.size_guide.body);
  const hideMobile = contiansKnitWoven(settings.size_guide.header);
  const content_html = `
    <div class="Module-SizeGuide--mobile">
    <span class="Module-SizeGuide--dropdownTitle">Select a size:</span>
    <select onchange="ChangeDropdowns(value);" class="Module-${module_name}-Selector">
      ${dropdown}
    </select>
    <table id="mobile-table" class="Module-${module_name}__Table-mobile" cellspacing="0">
      ${table_heading}
      ${table_body}
    </table>
    </div>
  `;
  if (hideMobile) {
    return `
      <h6 class="Module-${module_name}--mobile-header">No Size Guide Found</h6>
    `;
  } else {
    return content_html;
  }
};
